
import HeaderSimple from '~/components/HeaderSimple'

export default {
  name: 'App',
  components: { HeaderSimple }
}
